<!--
 * @Author: mazhigang
 * @Date: 2023-07-03 17:43:22
 * @LastEditors: mazhigang
 * @LastEditTime: 2023-09-02 20:59:46
-->
<template>
  <div class="content">
    <system :leftList="leftList"></system>
    <div class="pageBox">
      <div class="breadcrumb">
        <el-breadcrumb separator="/">
          <el-breadcrumb-item :to="{ path: '/' }">首页</el-breadcrumb-item>
          <el-breadcrumb-item>供应商管理</el-breadcrumb-item>
        </el-breadcrumb>
      </div>
      <div class="pageSerch">
        <el-card class="box-card" shadow="never">
          <div slot="header" class="clearfix">
            <span class="cardTitle">供应商列表</span>
          </div>
          <el-form ref="ruleForm" :model="ruleForm">
            <el-row :gutter="24">
              <el-col :span="8">
                <el-form-item label="供应商名称">
                  <el-input
                    maxlength="50"
                    clearable
                    v-model="ruleForm.name"
                    placeholder="请输入供应商名称"
                  ></el-input>
                </el-form-item>
              </el-col>
              <el-col :span="8">
                <el-form-item label="状态">
                  <el-select
                    v-model="ruleForm.status"
                    placeholder="请选择状态"
                    style="margin-right: auto"
                  >
                    <el-option label="上架" value="0"></el-option>
                    <el-option label="下架" value="1"></el-option>
                  </el-select>
                </el-form-item>
              </el-col>
              <el-col :span="8">
                <el-form-item>
                  <el-button type="primary" @click="getList()" class="btn"
                    >查询</el-button
                  >
                  <el-button @click="resetForm()">重置</el-button>
                </el-form-item>
              </el-col>
            </el-row>
          </el-form>
        </el-card>
      </div>
      <div class="pageTab">
        <el-button
          type="primary"
          class="btn"
          style="margin-bottom: 16px"
          @click="add()"
          >添加</el-button
        >
        <el-table ref="scrollTable" :data="tableData" style="width: 100%">
          <el-table-column prop="appId" label="appId" align="center">
          </el-table-column>
          <el-table-column prop="name" label="供应商名称" align="center">
          </el-table-column>
          <el-table-column label="分类" align="center">
            <template slot-scope="scope">
              <span>{{ scope.row.categoryName }}</span>
            </template>
          </el-table-column>
          <el-table-column prop="province" label="城市" align="center">
          </el-table-column>
          <el-table-column prop="area" label="地区" align="center">
          </el-table-column>
          <el-table-column prop="address" label="服务地址" align="center">
          </el-table-column>
          <el-table-column prop="publishTime" label="发布时间" align="center">
          </el-table-column>
          <el-table-column label="状态" align="center">
            <template slot-scope="scope">
              <span class="redColor" v-if="scope.row.status == 1">停用</span>
              <span class="greenColor" v-if="scope.row.status == 0">启用</span>
            </template>
          </el-table-column>
          <el-table-column label="操作" align="center" width="180">
            <template slot-scope="scope">
              <div class="disAround">
                <div
                  class="operateBtn greenColor1"
                  @click="stop(scope.row)"
                  v-if="scope.row.status == 1"
                >
                  启用
                </div>
                <div
                  class="operateBtn redColor1"
                  @click="stop(scope.row)"
                  v-if="scope.row.status == 0"
                >
                  停用
                </div>
                <div class="operateBtn" @click="handleEdit(scope.row)">
                  编辑
                </div>
                <div
                  class="operateBtn redColor1"
                  @click="deleteItem(scope.row)"
                >
                  删除
                </div>
              </div>
            </template>
          </el-table-column>
        </el-table>
        <el-pagination
          @size-change="handleSizeChange"
          @current-change="handleCurrentChange"
          :page-sizes="[10, 20, 30, 50]"
          :page-size="pageSize"
          layout="total, prev, pager, next,sizes"
          :total="total"
        >
        </el-pagination>
      </div>
    </div>
  </div>
</template>

<script>
import system from "../../components/system_left.vue";
export default {
  components: {
    system,
  },
  data() {
    return {
      leftList: this.Plugins.operateData(),
      ruleForm: {
        name: "",
        status: "",
      },
      tableData: [],
      page: 1,
      pageSize: 10,
      total: 0,
    };
  },
  mounted() {
    this.getList();
  },
  methods: {
    add() {
      this.$router.push("/supplierAdd");
    },
    handleEdit(val) {
      this.$router.push({
        path: "/supplierAdd",
        query: {
          id: val.id,
        },
      });
    },
    resetForm() {
      this.ruleForm.name = "";
      this.ruleForm.status = "";
      this.getList();
    },
    handleSizeChange(val) {
      this.pageSize = val;
      this.getList();
    },
    handleCurrentChange(val) {
      this.page = val;
      this.getList();
    },
    getList() {
      let param = {
        page: this.page,
        pageSize: this.pageSize,
        queryParams: [],
      };
      if (this.ruleForm.name != "") {
        param.queryParams.push({
          name: "name",
          type: "input",
          value: this.ruleForm.name,
        });
      } else if (this.ruleForm.status != "") {
        param.queryParams.push({
          name: "sale_status",
          type: "select",
          values: [{ itemKey: this.ruleForm.status }],
        });
      }
      this.$axios
        .post(`/admapi/supplier/list`, param)
        .then(({ data }) => {
          this.tableData = data.items;
          this.total = data.page.totalRows;
        })
        .catch()
        .finally();
    },
    stop(val) {
      this.$confirm(val.status == 1 ? "是否启用" : "是否禁用", "提示", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        type: "warning",
      })
        .then(() => {
          let param = {
            id: val.id,
            state: val.status == 0 ? 1 : 0,
          };
          this.$axios
            .post(`/admapi/supplier/publish`, param)
            .then(({ data }) => {
              this.$message({
                message: val.status == 0 ? "禁用成功" : "启用成功",
                type: "success",
              });
              this.getList();
            })
            .catch()
            .finally();
        })
        .catch(() => {});
    },
    deleteItem(val) {
      this.$confirm("是否删除", "提示", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        type: "warning",
      })
        .then(() => {
          this.$axios
            .post(`/admapi/supplier/delete/${val.id}`)
            .then(({ data }) => {
              this.$message({
                message: "删除成功",
                type: "success",
              });
              this.getList();
            })
            .catch()
            .finally();
        })
        .catch(() => {});
    },
  },
};
</script>
<style scoped></style>
